import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../elements/Filter';
import { Fields, defaultDateRange } from './fields';
import styles from './styles.scoped.css';
import { setFilterAction } from '../../../pages/SinkronisasiMerchant/actions';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

function SinkronisasiFilter() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [valueDate, setValueDate] = useState(defaultDateRange);

  const { filter: values } = useSelector(
    (state) => state.logsSyncMerchant.table
  );
  const dropdownData = {
    status: [
      { value: '', label: 'Semua Status' },
      { value: '1', label: 'Gagal Daftar' },
      { value: '2', label: 'Gagal Perbarui Data' },
    ],
  };

  const handleChangeValues = (name, value) => {
    if (name === 'status') {
      dispatch(
        setFilterAction({ key: 'table', filter: { ...values, status: value } })
      );
    }
    if (name === 'date') {
      dispatch(
        setFilterAction({
          key: 'table',
          filter: {
            ...values,
            startDate: dayjs(value[0]).format('YYYY-MM-DD'),
            endDate: dayjs(value[1]).format('YYYY-MM-DD'),
          },
        })
      );
    }
  };
  const handleReset = () => {
    dispatch(
      setFilterAction({
        key: 'table',
        filter: {
          status: '',
          startDate: dayjs(defaultDateRange[0]).format('YYYY-MM-DD'),
          endDate: dayjs(defaultDateRange[1]).format('YYYY-MM-DD'),
        },
      })
    );
    setValueDate(defaultDateRange);
    navigate('/merchant/sinkronisasi-merchant');
  };

  useEffect(() => {
    dispatch(
      setFilterAction({
        key: 'table',
        filter: {
          status: '',
          startDate: dayjs(defaultDateRange[0]).format('YYYY-MM-DD'),
          endDate: dayjs(defaultDateRange[1]).format('YYYY-MM-DD'),
        },
      })
    );
  }, []);
  return (
    <Filter
      className={styles.fields}
      fields={Fields({
        values,
        handleChangeValues,
        setValueDate,
        valueDate,
        dropdownData,
      })}
      handleReset={handleReset}
    />
  );
}

export default SinkronisasiFilter;
